import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { TEALIUM_PAGE_EDIT_PAY_AND_POST } from 'src/app/v1/analytics';
import { useTrackingTimer } from 'src/app/v1/dataAnalytics/PageViewTracker/hooks/useTrackingTimer';
import { editPayAndPostPageSelector } from 'src/app/v1/dataAnalytics/PageViewTracker/selectors/editPayAndPostPageSelector';
import { getTrackerSelector } from 'src/app/v1/dataAnalytics/utils/getTrackerSelector';
import { sendPageTracking } from 'src/app/v1/dataAnalytics/utils/sendPageTracking';

const selector = getTrackerSelector(editPayAndPostPageSelector);

export const EditPayAndPostPageTracker = () => {
  const { page, isPageReady, isDataCleanUpComplete, hasHirerInfo } =
    useSelector(selector);

  const { eventSent, setEventSent } = useTrackingTimer(
    TEALIUM_PAGE_EDIT_PAY_AND_POST,
    () => sendPageTracking(page),
  );

  useEffect(() => {
    if (
      page &&
      page === TEALIUM_PAGE_EDIT_PAY_AND_POST &&
      isPageReady &&
      isDataCleanUpComplete &&
      hasHirerInfo &&
      !eventSent
    ) {
      sendPageTracking(page);
      setEventSent(true);
    }
  }, [
    page,
    hasHirerInfo,
    isPageReady,
    isDataCleanUpComplete,
    eventSent,
    setEventSent,
  ]);

  return <></>;
};
